import { getVisibleFieldErrors } from '@/lib/utils/validationHelpers'

export default {
  props: {
    modelValue: [String, Boolean, Number, Object],
    field: Object,
    isValidationRun: Boolean,
    customServerErrorMessage: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    isLabelVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model() {
      return this.field.$model || this.field
    },
    errors() {
      return getVisibleFieldErrors(this.field, this.customServerErrorMessage)
    },
  },
}
